import clsx from 'clsx'
import styles from './FormComponentErrorMessageUI.module.scss'

export const FormComponentErrorMessageUI = ({
  children,
}: React.HTMLAttributes<HTMLSpanElement>) => (
  <span className={clsx(styles.errorMessage, 'form-component-error-message')}>{children}</span>
)
